// RESTANCE THEME — restance.js

document.addEventListener('DOMContentLoaded', function() {

  // ── CUSTOM CURSOR ──
  const cur = document.getElementById('cur');
  const curTxt = document.getElementById('curTxt');
  if (cur) {
    document.addEventListener('mousemove', function(e) {
      cur.style.left = e.clientX + 'px';
      cur.style.top = e.clientY + 'px';
      if (curTxt) { curTxt.style.left = (e.clientX + 24) + 'px'; curTxt.style.top = e.clientY + 'px'; }
    });
    document.querySelectorAll('.prod-card').forEach(function(el) {
      el.addEventListener('mouseenter', function() { cur.classList.add('shop'); if(curTxt) curTxt.classList.add('show'); });
      el.addEventListener('mouseleave', function() { cur.classList.remove('shop'); if(curTxt) curTxt.classList.remove('show'); });
    });
    document.querySelectorAll('a, button, .rcs-pill, .nav-icon, .nav-cart, .cat, .rsi-tag-btn').forEach(function(el) {
      el.addEventListener('mouseenter', function() { cur.classList.add('hover'); });
      el.addEventListener('mouseleave', function() { cur.classList.remove('hover'); });
    });
  }

  // ── NAV SCROLL ──
  var nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // ── COLOUR SLIDER ──
  var cmp = document.getElementById('rcs-cmp');
  if (cmp) {
    var cRight = document.getElementById('rcs-right');
    var cHandle = document.getElementById('rcs-handle');
    var cLeft = document.getElementById('rcs-left');
    var lName = document.getElementById('rcs-left-name');
    var rName = document.getElementById('rcs-right-name');
    var drag = false;
    function pct(e) { var r = cmp.getBoundingClientRect(), x = e.touches ? e.touches[0].clientX : e.clientX; return Math.max(5, Math.min(95, ((x-r.left)/r.width)*100)); }
    function setPos(p) { if(cRight) cRight.style.clipPath = 'inset(0 0 0 '+p+'%)'; if(cHandle) cHandle.style.left = p+'%'; }
    cmp.addEventListener('mousedown', function(e) { drag=true; setPos(pct(e)); });
    cmp.addEventListener('touchstart', function(e) { drag=true; setPos(pct(e)); }, {passive:true});
    document.addEventListener('mousemove', function(e) { if(drag) setPos(pct(e)); });
    document.addEventListener('touchmove', function(e) { if(drag) setPos(pct(e)); }, {passive:true});
    document.addEventListener('mouseup', function() { drag=false; });
    document.addEventListener('touchend', function() { drag=false; });
    setPos(50);
    document.querySelectorAll('.rcs-pill').forEach(function(p) {
      p.addEventListener('click', function() {
        document.querySelectorAll('.rcs-pill').forEach(function(x) { x.classList.remove('rcs-active'); });
        p.classList.add('rcs-active');
        if (p.dataset.side === 'left') { if(cLeft) cLeft.style.background = p.dataset.bg; if(lName) lName.textContent = p.dataset.name; }
        else { if(cRight) cRight.style.background = p.dataset.bg; if(rName) rName.textContent = p.dataset.name; }
      });
    });
  }

  // ── FLOATING CART ──
  // Hook into Shopify's cart icon
  document.querySelectorAll('a[href="/cart"], .header__icon--cart, [data-cart-icon-bubble]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      rfcOpen();
    });
  });

  // Listen for add to cart events
  document.addEventListener('dispatch:cart:update', function() { rfcFetch(); });

  // Hook into quick-add buttons
  document.querySelectorAll('.quick-add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest('.prod-card');
      var name = card ? card.querySelector('.prod-name') : null;
      var price = card ? card.querySelector('.price') : null;
      if (name && price) rfcAdd(name.textContent, price.textContent);
    });
  });

});

// ── CART FUNCTIONS ──
window.rfcOpen = function() {
  var d = document.getElementById('rfcDrawer');
  var o = document.getElementById('rfcOverlay');
  if(d) d.classList.add('rfc-open');
  if(o) o.classList.add('rfc-open');
  document.body.style.overflow = 'hidden';
  rfcFetch();
};

window.rfcClose = function() {
  var d = document.getElementById('rfcDrawer');
  var o = document.getElementById('rfcOverlay');
  if(d) d.classList.remove('rfc-open');
  if(o) o.classList.remove('rfc-open');
  document.body.style.overflow = '';
};

window.rfcFetch = function() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {

      var total = document.getElementById('rfcTotal');
      var body = document.getElementById('rfcBody');

      if(total) {
        total.textContent = '$' + (cart.total_price / 100).toFixed(2) + ' NZD';
      }

      if(!body) return;

      if(!cart.items.length) {
        body.innerHTML =
          '<div class="rfc-empty">' +
          '<div class="rfc-empty-icon">BAG</div>' +
          '<p>Your bag is empty</p>' +
          '</div>';
        return;
      }

      body.innerHTML = cart.items.map(function(item) {

        return `
        <div class="rfc-item">

          <img class="rfc-item-img" src="${item.image}" alt="${item.product_title}">

          <div class="rfc-item-info">

            <div class="rfc-item-name">
              ${item.product_title}
            </div>

            <div class="rfc-item-meta">
              ${item.variant_title || ''}
            </div>

            <div class="rfc-item-price">
              $${(item.price / 100).toFixed(2)}
            </div>

            <div class="rfc-controls">

              <button onclick="rfcChange('${item.key}', ${item.quantity - 1})">
                −
              </button>

              <span>
                ${item.quantity}
              </span>

              <button onclick="rfcChange('${item.key}', ${item.quantity + 1})">
                +
              </button>

              <button onclick="rfcRemove('${item.key}')" class="rfc-remove">
                Remove
              </button>

            </div>

          </div>

        </div>
        `;

      }).join('');

    })
    .catch(function(error){
      console.log(error);
    });
};


window.rfcChange = function(id, qty) {

  if(qty < 0) qty = 0;

  fetch('/cart/change.js', {
    method:'POST',
    headers:{
      'Content-Type':'application/json'
    },
    body:JSON.stringify({
  id:id,
  quantity:qty
})
  })
  .then(function(){
    rfcFetch();
  });

};


window.rfcRemove = function(id) {

  fetch('/cart/change.js', {
    method:'POST',
    headers:{
      'Content-Type':'application/json'
    },
    body:JSON.stringify({
      id:id,
      quantity:0
    })
  })
  .then(function(){
    rfcFetch();
  });

};

window.rfcAdd = function(name, price) {
  var body = document.getElementById('rfcBody');
  var total = document.getElementById('rfcTotal');
  if(body) body.innerHTML = '<div class="rfc-empty"><div class="rfc-empty-icon">✓</div><p>Added to bag!</p></div>';
  rfcOpen();
  setTimeout(rfcFetch, 500);
};
// ========================
// MOBILE MENU
// ========================

const hamburger = document.getElementById("hamburger");
const mobileMenu = document.getElementById("mobileMenu");

if (hamburger && mobileMenu) {

  hamburger.addEventListener("click", function () {
    mobileMenu.classList.toggle("open");
  });

  document.querySelectorAll("#mobileMenu a").forEach(function(link){
    link.addEventListener("click", function(){
      mobileMenu.classList.remove("open");
    });
  });

}